import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const s = {
    LayoutChipContent: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 18px;
    font-weight: 400;
    line-height: 26px;

    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    text-align: center;

    & > span {
      font-size: 14px;
    }
  `,
};
